import React from 'react';
import PropTypes from 'prop-types';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import SimpleSelect from '../../../SimpleSelect/SimpleSelectView';
import AdvForm from '../../../../CommonComponents/AdvForm';
import InputPercentage from '../../../InputPercentage/InputPercentageView';
import Validation from '../../../Validation/ValidationContainer';
import ButtonWithLoading from '../../../ButtonWithLoading/ButtonWithLoadingContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';

export const withEmptyStringWhenNull = value => (value === null ? '' : value);
export const withNullWhenEmptyOption = option => (option.value === null ? null : option);

const MortgageView = ({
  branch,
  workflowId,
  clientId,
  hasPlanToGetMortgage,
  alreadyHadMortgage,

  selectedMortgageOptionOrDefault,
  mortgageTypeOptionsOrDefault,
  mortgageTypeChanged,

  nullableMortgageInterestRate,
  mortagageInterestRateChanged,

  nullableMortgagePMI,
  mortgagePMIChanged,

  nullableMortgageType,

  marketValue,
  desiredPurchaseYear,
  purchaseAtRetirement,
  downpayment,
  name,
  id,

  nullableMonthlyHoa,
  nullablePropertyTax,
  nullableHomeInsurancePerYear,

  onSave,
  onCancelled,
  isInSummaryEdit,
  nextIterators,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    canSkip={!hasPlanToGetMortgage && !alreadyHadMortgage}
  >
    <Validation
      workflowId={workflowId}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.Mortgage`}
    />
    <h2 className="h2">Please add your mortgage information.</h2>
    <AdvForm className="AccountAddEditView">
      <ul className="form-input-list">
        <li className="form-input">
          <SimpleSelect
            placeholder="Mortgage Type"
            id="adv-mortgage-type"
            className="no-horizontal-scroll sm"
            isLeftAligned
            value={withNullWhenEmptyOption(selectedMortgageOptionOrDefault)}
            options={mortgageTypeOptionsOrDefault}
            onValueChange={mortgageTypeChanged(workflowId)}
          />
        </li>
        <li className="form-input">
          <InputPercentage
            placeholder="Interest Rate"
            placeholderClassName="adv-workflows-placeholder-small"
            maxLength="256"
            className="accounts"
            isLeftAligned
            value={withEmptyStringWhenNull(nullableMortgageInterestRate)}
            onBlur={mortagageInterestRateChanged(workflowId)}
            onChange={mortagageInterestRateChanged(workflowId)}
            id="adv-workflow-interest-rate"
            decimalScale={3}
          />
        </li>
        <li className="form-input">
          <InputPercentage
            placeholder="Private Mortgage Insurance (PMI)"
            maxLength="256"
            className="accounts"
            isLeftAligned
            value={withEmptyStringWhenNull(nullableMortgagePMI)}
            onBlur={mortgagePMIChanged(workflowId)}
            onChange={mortgagePMIChanged(workflowId)}
            id="adv-workflow-pmi"
          />
        </li>
      </ul>
      <div className="footer">
        <button
          type="button"
          className="adv-workflow-navigation-cancel-button"
          onClick={onCancelled(workflowId, marketValue, isInSummaryEdit, nextIterators)}
        >
          Cancel
        </button>
        <ButtonWithLoading
          workflowId={workflowId}
          type="button"
          className="adv-workflow-navigation-next-save-button"
          onClick={onSave(
            workflowId,
            clientId,
            desiredPurchaseYear,
            purchaseAtRetirement,
            downpayment,
            marketValue,

            nullableMortgageType,
            nullableMortgageInterestRate,
            nullableMortgagePMI,

            nullableMonthlyHoa,
            nullablePropertyTax,
            nullableHomeInsurancePerYear,
            isInSummaryEdit,
            name,
            id,
          )}
        >
          Save Mortgage
        </ButtonWithLoading>
      </div>
    </AdvForm>
  </AdvWorkflowStep>
);

MortgageView.defaultProps = {
  nullableMortgageType: null,
  nullableMortgagePMI: null,
  nullableMortgageInterestRate: null,

  nullableMonthlyHoa: null,
  nullablePropertyTax: null,
  nullableHomeInsurancePerYear: null,
};

MortgageView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number).isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  clientId: PropTypes.string.isRequired,
  hasPlanToGetMortgage: PropTypes.bool.isRequired,
  alreadyHadMortgage: PropTypes.bool.isRequired,
  workflowId: PropTypes.string.isRequired,
  mortgageTypeOptionsOrDefault: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isInSummaryEdit: PropTypes.bool.isRequired,
  selectedMortgageOptionOrDefault: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }).isRequired,

  mortagageInterestRateChanged: PropTypes.func.isRequired,
  mortgagePMIChanged: PropTypes.func.isRequired,
  mortgageTypeChanged: PropTypes.func.isRequired,

  marketValue: PropTypes.number.isRequired,
  nullableMortgageInterestRate: PropTypes.number,
  nullableMortgagePMI: PropTypes.number,

  nullableMonthlyHoa: PropTypes.number,
  nullablePropertyTax: PropTypes.number,
  nullableHomeInsurancePerYear: PropTypes.number,

  nullableMortgageType: PropTypes.number,

  desiredPurchaseYear: PropTypes.number.isRequired,
  purchaseAtRetirement: PropTypes.number.isRequired,
  downpayment: PropTypes.number.isRequired,

  onCancelled: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,

  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default MortgageView;
